var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-add-liquidity"},[_c('f-view-transition',{attrs:{"watch-route":"","views-structure":_vm.viewsStructure}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }